module.exports = __webpack_public_path__ + "img/giggle_cointreasure.435af16.png";